import api from '@/api/api';
import router from '@/router';
import { dictionary } from '@/shared/services/dictionary';
import { isNull } from '@/shared/utils/utils';
import moment from 'moment';
import { Field, Icon, CellGroup, DatetimePicker, Popup, Form, Uploader, Button, DropdownMenu, DropdownItem, Area } from 'vant';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  components: {
    [Field.name]: Field,
    [Icon.name]: Icon,
    [CellGroup.name]: CellGroup,
    [DatetimePicker.name]: DatetimePicker,
    [Popup.name]: Popup,
    [Form.name]: Form,
    [Uploader.name]: Uploader,
    [Button.name]: Button,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Area.name]: Area
  }
})
export default class EducateResumeEdit extends Vue {
  // 正在提交
  submitting = false;
  openId = '';
  isPool: any = 0; // 人才库进入（1）或招聘进入（0）
  resumeInfo: any = {}; // 简历信息
  itemInfo: any = {};
  resumeId: any = '';
  id: any = '';

  isUnifiedRecruitOptions: any[] = [{ text: '是', value: "true" }, { text: '否', value: "false" }];
  // 熟练程度选项
  knowLevelList: any[] = [];
  // 日期弹窗的值
  dateValues: any = {};
  // 日期弹窗的状态
  dateShowState: any = {};
  // 地址弹窗的状态
  areaShowState: any = {};
  // 地址控件的值
  areaValues: any = {};

  areaList: any = {
    // eslint-disable-next-line @typescript-eslint/camelcase
    province_list: {},
    // eslint-disable-next-line @typescript-eslint/camelcase
    city_list: {}
  }

  created() {
    this.isPool = sessionStorage.getItem('isPool');
    const wechatUser = JSON.parse(sessionStorage.getItem('wechatUser') || '{}');
    this.openId = wechatUser.openid;
    console.log(this.openId);
    this.resumeId = this.$route.query.resumeId || '';
    this.id = this.$route.query.id || '';
  }

  mounted() {
    if (this.resumeId) {
      this.initResumeInfo();
    }
  }

  // 初始化简历
  initResumeInfo() {
    const resumeApi = this.isPool === '1' ? api.getTalentPoolResume : api.getRecruitResume;
    resumeApi({ openId: this.openId, id: this.resumeId })
      .then(
        (res: any) => {
          this.resumeInfo = res.resumeInfo;
          if (this.id) {
            this.getEditData();
          }
        }
      )
  }

  getEditData() {
    const item = this.resumeInfo.find((item: any) => {
      return item.id === this.id;
    })
    if (item) {
      this.itemInfo = item;
    }
  }



  submit() {
    if (this.submitting) {
      return;
    }
    this.submitting = true;
    if (!this.id) {
      if (!this.resumeInfo) {
        this.resumeInfo = {};
      }
    }
    this.editResumeInfo();
  }

  editResumeInfo() {
    const isPool = sessionStorage.getItem('isPool');
    const editResumeApi = isPool === '1' ? api.editTalentPoolResume : api.editRecruitResume;

    const entity = {
      openId: this.openId,
      resumeInfo: this.resumeInfo
    }
    editResumeApi(entity).then(
      res => {
        this.$router.push(`/resume-detail?resumeId=${this.resumeId}`)
      }
    ).finally(() => { 
      this.submitting = false;
    });
  }
}